import { inject, Injectable } from '@angular/core';

import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import { AllEnterpriseModule, LicenseManager } from 'ag-grid-enterprise';

import { BaasAppState } from '@lvflanders/bar';
import { BarInitializedHook } from '@lvflanders/bar-ng';

@Injectable()
/** Lifecycle hook for BAR ag grid module. */
export class BarAgGridInitializedHook implements BarInitializedHook {
    readonly #state = inject(BaasAppState, { optional: true });

    _framework = true;

    run(): void {
        // Register all features
        ModuleRegistry.registerModules([AllCommunityModule, AllEnterpriseModule]);

        if (this.#state != null) {
            // set ag-Grid license key after BAR is initialized
            try {
                LicenseManager.setLicenseKey(this.#state.config.agGridLicense);
            } catch (error) {
                console.warn('License manager not found, are you sure ag-Grid has been added to the project?');
            }
        }
    }
}
